import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { AddModalForm } from "~/components/specifics/settings/imports/[importType]/import_conversions/AddModalForm";
import { useImportConversions } from "~/hooks/admin/useImportConversions";
import { buildDefault, validationSchema } from "~/models/ImportConversion";
import type { ImportType } from "~/models/ImportLog";
import { isSuccess } from "~/utils/api/api_handler";
import { create } from "~/utils/api/ImportConversion";

type Props = {
	handleClose: () => void;
	importType: ImportType;
};

export const AddModal: React.FC<Props> = ({
	importType,
	handleClose
}: Props) => {
	const { mutate } = useImportConversions().useIndex(importType);
	const methods = useForm({
		defaultValues: buildDefault(importType),
		mode: "onBlur",
		resolver: yupResolver(validationSchema)
	});
	const onClickSubmit = React.useCallback(() => {
		methods.handleSubmit(async (values) => {
			const response = await create(importType, values);
			if (isSuccess(response)) {
				await mutate();
				handleClose();
				toast.success("取込変換設定を追加しました。");
				return;
			}
			toast.error("取込変換設定の追加に失敗しました。");
		})();
	}, [handleClose, importType, methods, mutate]);
	return (
		<Modalv2 isOpen onClose={handleClose}>
			<ModalHeader title="取込変換設定の追加" />
			<ModalBody>
				<FormProvider {...methods}>
					<AddModalForm />
				</FormProvider>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={handleClose} variant="secondary">
						保存せず閉じる
					</Button>
				}
				rightArea={
					<Button onClick={onClickSubmit} variant="primary">
						保存
					</Button>
				}
			/>
		</Modalv2>
	);
};
